import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Account } from "@/components";
import styles from "./AccountPage.module.scss";


export const AccountPage: FC = () => {

  return (
    <div className={styles.AccountPanelContainer} data-testid="test__account_container">
      <Stack spacing="large">
        <Account />
      </Stack>
    </div>
  );
};

export default AccountPage;
